/**
 * 連結リストを操作するclass
 */
class LinkedList {
  /**
   * 前のnodeを返す
   * @param {object} node - nodeオブジェクト
   * @return {object} - 前のnodeを返す。存在しなければnullを返す
   */
  static getLinkedListPrev(node) {
    return (node != null && node._prev != null) ? node._prev : null;
  }

  /**
   * 連結リストのroot headを返す
   * @param {object} node - nodeオブジェクト
   * @return {object} - 先頭のnodeを返す。存在しなければnullを返す
   */
  static getLinkedListAncestor(node) {
    if(node == null) return null;
    let iterator = node;
    let parent = null;
    while(iterator != null) {
      parent = iterator;
      iterator = iterator._prev;
    }

    return parent;
  }
}

export default LinkedList;